export const CARD_BORDER_EXTRA_SPACE = 2;
export const CARD_MARGIN_TOP = 16;
